import cn from "classnames";
import React, { useState } from "react";

import { randomInteger } from "../../helpers";
import * as styles from "./PageBanner.module.css";

type RenderProp = (props?: object) => JSX.Element | null;

let setBannerRenderer: (renderBanner: RenderProp) => void;
let currentBannerId = 0;

const displayBanner = (component: RenderProp) => {
  if (currentBannerId) {
    console.warn("Double rendering banner. Another banner is already visible.");
  }

  setBannerRenderer(component);

  const newBannerId = randomInteger(1000);
  currentBannerId = newBannerId;

  return () => hideBanner(newBannerId);
};

const hideBanner = (bannerId: number) => {
  if (bannerId !== currentBannerId) {
    console.warn("Attempt to hide a different banner blocked");
    return;
  }

  hideBannerUnconditionally();
};

const hideBannerUnconditionally = () => {
  setBannerRenderer(() => null);
  currentBannerId = 0;
};

// todo @ anmarc / zaaslam: handle multiple banners trying to get displayed at the same time
export const PageBanner = () => {
  const [renderBanner, setRenderBanner] = useState<RenderProp>(() => () => null);
  setBannerRenderer = render => setRenderBanner(() => render);

  const renderedBanner = renderBanner();
  return (
    <div
      id="pageBannerContainer"
      className={cn(
        styles.bannerContainer,
        {
          [styles.hidden]: !renderedBanner,
        },
        {
          [styles.visible]: !!renderedBanner,
        }
      )}
    >
      {renderedBanner && <div>{renderedBanner}</div>}
    </div>
  );
};

export const PageBannerManager = {
  displayBanner,
  hideAllBanners: hideBannerUnconditionally,
};
